export * from './config-certificate-request';
import './config-certificate-request.scss';
